export const TEMPLATE_TYPES = {
  FREE_TEXT: 'FREE_TEXT',
  SOAP: 'SOAP'
}

export const TEMPLATE_TYPE_MAP = {
  [TEMPLATE_TYPES.FREE_TEXT]: 'Texto livre',
  [TEMPLATE_TYPES.SOAP]: 'SOAP'
}

export const TEMPLATE_TYPE_ICON = {
  [TEMPLATE_TYPES.FREE_TEXT]: 'icEdit',
  [TEMPLATE_TYPES.SOAP]: 'icScript'
}

export const TEMPLATE_COMPONENT_TYPE = {
  SUBJECTIVE: 'SUBJECTIVE',
  OBJECTIVE: 'OBJECTIVE',
  EVALUATION: 'EVALUATION',
  PLAN: 'PLAN',
  EXCUSE_NOTES: 'EXCUSE_NOTES',
  FREE_TEXT: 'FREE_TEXT',
  TREATED_BY: 'TREATED_BY',
  CONTRACTUAL_RISK_CALCULATOR: 'CONTRACTUAL_RISK_CALCULATOR'
}

export const TEMPLATE_COMPONENTS = {
  [TEMPLATE_COMPONENT_TYPE.SUBJECTIVE]: {
    fixed: true,
    name: 'CRSubjectiveComponent',
    url: 'components/clinicalRecord/molecules/template/components/CRSubjectiveComponent',
    field: 'subjective'
  },
  [TEMPLATE_COMPONENT_TYPE.OBJECTIVE]: {
    fixed: true,
    name: 'CRObjectiveComponent',
    url: 'components/clinicalRecord/molecules/template/components/CRObjectiveComponent',
    field: 'objective'
  },
  [TEMPLATE_COMPONENT_TYPE.EVALUATION]: {
    fixed: true,
    name: 'CREvaluationComponent',
    url: 'components/clinicalRecord/molecules/template/components/CREvaluationComponent',
    field: 'clinicalEvaluation'
  },
  [TEMPLATE_COMPONENT_TYPE.PLAN]: {
    fixed: true,
    name: 'CRPlanComponent',
    url: 'components/clinicalRecord/molecules/template/components/CRPlanComponent',
    field: 'plan'
  },
  [TEMPLATE_COMPONENT_TYPE.FREE_TEXT]: {
    fixed: true,
    name: 'CRFreeTextComponent',
    url: 'components/clinicalRecord/molecules/template/components/CRFreeTextComponent',
    field: 'description'
  },
  [TEMPLATE_COMPONENT_TYPE.EXCUSE_NOTES]: {
    name: 'CRExcuseNotesComponent',
    url: 'components/clinicalRecord/molecules/template/components/CRExcuseNotesComponent',
    field: 'excuseNotes'
  },
  [TEMPLATE_COMPONENT_TYPE.TREATED_BY]: {
    name: 'CRTreatedByComponent',
    url: 'components/clinicalRecord/molecules/template/components/CRTreatedByComponent',
    field: 'treatedBy'
  },
  [TEMPLATE_COMPONENT_TYPE.CONTRACTUAL_RISK_CALCULATOR]: {
    name: 'CRContractualRiskCalculatorComponent',
    url: 'components/clinicalRecord/molecules/template/components/CRContractualRiskCalculatorComponent',
    field: 'contractualRisks'
  }
}

export const DEFAULT_SOAP_TEMPLATE = [
  { componentType: TEMPLATE_COMPONENT_TYPE.SUBJECTIVE, order: 0 },
  { componentType: TEMPLATE_COMPONENT_TYPE.OBJECTIVE, order: 1 },
  { componentType: TEMPLATE_COMPONENT_TYPE.EVALUATION, order: 2 },
  { componentType: TEMPLATE_COMPONENT_TYPE.PLAN, order: 3 }
]

export const DEFAULT_FREE_TEXT_TEMPLATE = [
  { componentType: TEMPLATE_COMPONENT_TYPE.FREE_TEXT, order: 0 }
]

export const TEMPLATE_OPTIONS = [
  {
    value: TEMPLATE_TYPES.FREE_TEXT,
    name: TEMPLATE_TYPE_MAP.FREE_TEXT,
    icon: TEMPLATE_TYPE_ICON[TEMPLATE_TYPES.FREE_TEXT],
    components: [...DEFAULT_FREE_TEXT_TEMPLATE]
  },
  {
    value: TEMPLATE_TYPES.SOAP,
    name: TEMPLATE_TYPE_MAP.SOAP,
    icon: TEMPLATE_TYPE_ICON[TEMPLATE_TYPES.SOAP],
    components: [...DEFAULT_SOAP_TEMPLATE]
  }
]

export const DEFAULT_COMMANDS_PROPS = {
  removable: {
    type: Boolean
  },
  suggestionMacros: {
    type: Array,
    default: () => []
  },
  searchMacro: {
    type: Function,
    default: () => []
  },
  searchDisease: {
    type: Function,
    default: () => []
  },
  component: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  clinicalRecordType: {
    type: String,
    default: null
  }
}

export const MARKDOWN_LINK_CONDITION = 'conditionCode'
